(function ($) {
	// On Dom Ready
	$(function () {
		// Swiper slider
		$(".swiper.photoslider-b").each(function (index, element) {
			// disable if only one slide
			if ($(element).find(".swiper-slide").length > 1) {
				const the_slider = new Swiper(element, {
					loop: true,
					slidesPerView: 1,
					lazy: true,
					simulateTouch: false,

					autoplay: false,
					speed: 700,

					// If we need pagination
					pagination: {
						el: $(element).find(".swiper-pagination")[0],
						clickable: true,
					},

					// Navigation arrows
					navigation: {
						nextEl: $(element).find(".swiper-button-next")[0],
						prevEl: $(element).find(".swiper-button-prev")[0],
					},
				});
			} else {
				$(element).addClass("disabled");
			}
		});

		alignPhotoSliderBArrow();
	});

	$(window).on('resize', function(){
		alignPhotoSliderBArrow();
	});

	function alignPhotoSliderBArrow(){
		// check if screen size < 1200px
		if ($(window).width() < 1200) {
			$(".swiper.photoslider-b").each(function (index, element) {
				if(!$(element).hasClass("disabled")) {
					const arrows = $(element).find(".swiper-navigation-wrapper");
					const slidePhoto = $(element).find(".swiper-slide-active .slide-photo").first();

					// get bottom position of slidePhoto
					const slidePhotoBottom = slidePhoto.offset().top + slidePhoto.outerHeight() - $(element).offset().top + 30;

					// change top position of arrows
					arrows.css("top", slidePhotoBottom + "px");
				}
			});
		}
		else{
			$(".swiper.photoslider-b").each(function (index, element) {
				const arrows = $(element).find(".swiper-navigation-wrapper");
				arrows.css("top", "auto");
				arrows.css("bottom", "70px");
			});
		}
	}
})(jQuery);
